// -*- Mode: rjsx -*-
import React from 'react';

import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import ScheduleIcon from '@mui/icons-material/Schedule';

import { ResponseOption } from '..';
import { FancyTextEntry } from '../../../ui';

function DelaySheet(props) {
    return (
        <FancyTextEntry />
    );
}

function DelayResponse(props) {
    props = {type: "delay",
             primary: "Set a delay",
             secondary: "Waiting to hear back from someone, or the place isn't open",
             icon: <ScheduleIcon />,
             ...props};
    return (
        <ResponseOption
          {...props }
          sheet={<DelaySheet {...props}  />}
          /* button={<DelayButton {...props}  />}           */
        />
    );
}



export { DelayResponse };
